import { postFetch } from '../fetch';

import { apiConfig } from '../config';

import { AssignmentInfo, FullCLesson } from '../../../typings/';

export function postPublishClesson(clessonId: number, assignmentInfo: AssignmentInfo): Promise<FullCLesson> {
    const { apiPostPublishCLesson } = apiConfig.getStaticUrls();

    if (clessonId) {
        return postFetch(apiPostPublishCLesson, {
            clessonId, assignmentInfo,
        });
    }

    throw new Error('Trying to publish clesson without clessonId!');
}
